module.exports = __webpack_public_path__ + "img/geiz.e0b065c4.png";